export type RaidstratsPlayer = {
  name: string
  className: string
}

type Props = {
  raidPlanId: string
  players: RaidstratsPlayer[]
}

const RaidstratsContainer = ({ raidPlanId, players }: Props) => {
  const playersValue = `0,${players
    .map((player) => `${player.name}|${player.className}`)
    .join(',')}`
  const searchParams = new URLSearchParams({
    embed: 'true',
    id: raidPlanId,
    animation: 'true',
    hidetrails: 'true',
  })
  if (playersValue) {
    searchParams.set('players', playersValue)
  }
  return (
    <div className='w-full overflow-hidden rounded-md'>
      <iframe
        src={`https://raidstrats.gg/planner?${searchParams.toString()}`}
        title='Raid plan'
        className='w-full aspect-video'
      />
    </div>
  )
}

export default RaidstratsContainer
